import Vue from "vue";
const vm = new Vue()

export default ( vm.$THEME.fixedSizeLable && new Date().getTime() > new Date('2022-05-01 00:00:00').getTime() ) 
    ? vm.$THEME.fixedSizeLable 
    : [
        {
            value: 'A4',
            text: 'A4'
        },
        {
            value: 'A5',
            text: 'A5'
        },
        {
            value: 'A6',
            text: 'A6'
        },
        {
            value: 'receipt',
            text: 'ใบเสร็จ'
        },
        {
            value: 'letter',
            text: 'ซองจดหมาย'
        },
        {
            value: 'letter4x6',
            text: 'ซองจดหมาย ขนาด 4*6'
        },
        {
            value: 'sticker',
            text: 'ขนาดสติกเกอร์ 8x8 เซนติเมตร'
        },
        {
            value: 'sticker4x6',
            text: 'ขนาดสติกเกอร์ 4x6 นิ้ว'
        },
        {
            value: 'sticker100x75',
            text: 'ขนาดสติกเกอร์ 100x75 มิลลิเมตร'
        },
        {
            value: 'paperang',
            text: 'Paperang'
        }
    ]
